import { useLocation } from "react-router-dom-v5-compat";

import { LogInLink } from "features/sign-up/common-routes/components/form";
import SignUpFormButtons from "features/sign-up/components/SignUpFormButtons";
import { ModalWrapper } from "features/sign-up/sign-in-form/components/SignInCard/components/ModalWrapper";
import { RenderSignInFormProps } from "features/sign-up/sign-in-form/components/SignInCard/components/SignInCardCommon";

import { SignUpCardAppsContainerProps } from "../containers/SignUpCardAppsContainer";
import SignUpCardFlowsContainer from "../containers/SignUpCardFlowsContainer";

export default function SignUpCardPlurallApp(
  props: SignUpCardAppsContainerProps
) {
  const location = useLocation();

  const renderForm = (renderProps: RenderSignInFormProps) => (
    <ModalWrapper
      errorMessage={renderProps.errorMessage}
      headerMessage={renderProps.headerMessage}
      defaultHeaderMessage="Sign up"
    >
      <SignUpFormButtons
        accountType={props.accountType}
        setErrorMessage={renderProps.setErrorMessage}
        redirectAuthenticatedUserTo={renderProps.redirectAuthenticatedUserTo}
        linkToNextPage={props.linkToNextPageSSO || props.linkToNextPage}
      />
      <LogInLink loginLink={props.linkToSignIn} />
    </ModalWrapper>
  );

  return (
    <SignUpCardFlowsContainer {...props}>{renderForm}</SignUpCardFlowsContainer>
  );
}
